import EmptyRouterParent from '@/pmd/pages/EmptyRouterParent.vue'
import { RouteConfig } from 'vue-router'
import { automationRouteNames } from '@/routes/constants/location'
import { requireAuthAndLocation } from '../auth'
import {Modules} from '../../util/modules'

const workflowBuilder = () => import('@/pmd/pages/workflow/WorkflowMicroApp.vue').then(m => m.default)
const CampaignList = () =>
  import(
    /* webpackChunkName: "m-campaign-list" */ '@/pmd/pages/marketing/CampaignList.vue'
  ).then(m => m.default)
const CampaignNew = () =>
  import(
    /* webpackChunkName: "m-campaign-new" */ '@/pmd/pages/marketing/CampaignNew.vue'
  ).then(m => m.default)
const CampaignDetail = () =>
  import(
    /* webpackChunkName: "m-campaign-detail" */ '@/pmd/pages/marketing/CampaignDetail.vue'
  ).then(m => m.default)
const CampaignActivity = () =>
  import(
    /* webpackChunkName: "m-campaign-activity" */ '@/pmd/pages/marketing/CampaignActivity.vue'
  ).then(m => m.default)
const CampaignAccountsList = () =>
  import(
    /* webpackChunkName: "m-campaign-acc-list" */ '@/pmd/pages/marketing/CampaignAccountsList.vue'
  ).then(m => m.default)
const BulkCampaignsPage = () =>
  import(
    /* webpackChunkName: "m-bulk-campaigns" */ '@/pmd/pages/marketing/BulkCampaignsPage.vue'
  ).then(m => m.default)

const TriggersPage = () =>
  import(
    /* webpackChunkName: "triggers" */ '@/pmd/pages/triggers/TriggersPage.vue'
  ).then(m => m.default)

const TriggerDetailPage = () =>
  import(
    /* webpackChunkName: "trigger-detail" */ '@/pmd/pages/triggers/TriggerDetailPage.vue'
  ).then(m => m.default)

export const automationRoutes: RouteConfig[] = [ {
  path: 'automation',
  name: automationRouteNames.default,
  component: EmptyRouterParent,
  beforeEnter: requireAuthAndLocation,
  children: [
    {
      path: 'new-workflow',
      component: workflowBuilder,
      name: automationRouteNames.newWorkflows,
      beforeEnter: requireAuthAndLocation,
    },
    {
      path: 'workflows',
      name: automationRouteNames.workflows,
      component: workflowBuilder,
      beforeEnter: requireAuthAndLocation,
    },
    {
      path: 'setup-workflow',
      name: 'setupWorkflow',
      component: workflowBuilder,
      beforeEnter: requireAuthAndLocation,
    },
    {
      path: 'flowguard',
      name: automationRouteNames.flowGuard,
      component: workflowBuilder,
      beforeEnter: requireAuthAndLocation,
    },
    {
      path: 'campaigns',
      name: automationRouteNames.campaigns,
      component: CampaignList,
      beforeEnter: requireAuthAndLocation,
    },
    {
      path: 'campaigns/:campaign_id',
      name: automationRouteNames.campaignEdit,
      component: CampaignNew,
      beforeEnter: requireAuthAndLocation,
    },
    {
      path: 'campaigns/:campaign_id/detail',
      name: automationRouteNames.campaignDetail,
      component: CampaignDetail,
      beforeEnter: requireAuthAndLocation,
    },
    {
      path: 'campaigns/:campaign_id/list',
      name: automationRouteNames.campaignAccountsList,
      component: CampaignAccountsList,
      beforeEnter: requireAuthAndLocation,
    },
    {
      path: 'campaigns/activity',
      name: automationRouteNames.campaignActivity,
      component: CampaignActivity,
      beforeEnter: requireAuthAndLocation,
    },
    {
      path: 'bulk',
      name: automationRouteNames.bulkRequests,
      component: BulkCampaignsPage,
      beforeEnter: requireAuthAndLocation,
    },
    {
      path: 'triggers',
      name: automationRouteNames.triggers,
      component: TriggersPage,
      beforeEnter: requireAuthAndLocation,
    },
    {
      path: 'triggers/:trigger_id',
      name: automationRouteNames.triggerDetail,
      component: TriggerDetailPage,
      beforeEnter: requireAuthAndLocation,
      meta: { translations: [Modules.Task] },
    },
  ],
}]
